import { ReactComponent as SendSvg } from '../../../../assets/Send.svg';
import styled from '../../../../lib/theme';

export const TextAreaContainer = styled('div')`
  width: calc(100% - 7.5rem);
`;

export const MessageBoxRow = styled('div')`
  padding: 0 1rem 0rem;
`;

export const MessageBoxDivider = styled('div')`
  height: 10px;
  width: auto;
  margin: 0 6px;
  border-top: 1px solid #ddd;
`;

export const MessageInput = styled('textarea')`
  border: 0;
  outline: transparent;
  font-size: 1.6rem;
  resize: none;
  padding: 0.4rem 0.8rem;
  ::placeholder {
    color: #d8dcde;
  }
  width: 100%;
  min-height: 3.4rem;
  max-height: 8.5rem;
`;

export const SendIcon = styled(SendSvg)`
  ${({ theme }) => `
    [data-svg-class='Stroke'] {
      stroke: ${theme.sendButtonTextColor || theme.primaryAccentTextColor};
      fill: ${theme.sendButtonTextColor || theme.primaryAccentTextColor};
    }
  `}
`;
